import { useQuery  } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import CustomFormsDataService from "../../services/custom-forms-data-service/CustomFormsDataService";
import { RestError } from "../../services/rest-service/RestService";
import { IFormInstanceData } from "../../views/object-form-view/Models";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseCustomFormInstanceQueryParameters = {
    customerID: number,
    groupID: number,
    objectID: number,
    objectType: eLynxObjectTypeEnum,
    offline: boolean,
    startTime?: Date,
    endTime?: Date
    //sessionToken?: string
} & BaseUseQueryParameters<IFormInstanceData[]>

export function useCustomFormInstance(
    params: UseCustomFormInstanceQueryParameters
) {
    return useQuery<IFormInstanceData[] | undefined, RestError>(
        keys.list(params.customerID,
            params.groupID,
            params.objectID,
            params.objectType,
            params.offline,
            params.startTime,
            params.endTime,
            //params.sessionToken
            ),
        ({ signal }) => {

            if (params.customerID) {
                return CustomFormsDataService.getInstanceData(params.customerID,
                    params.groupID,
                    {
                        id: params.objectID,
                        objectType: params.objectType
                     } as IeLynxObject,
                    params.offline,
                    params.startTime,
                    params.endTime,
                    undefined,
                    signal
                );
            }
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
        }
    );
}

